



















































































import Vue from 'vue'
import Component from 'vue-class-component'
import EditHistoryCommentModal from '../../../../../../components/modals/EditHistoryCommentModal.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import { ESortOrder, ICollectionHistory, IResidentEventHistoryFiltersDTO, EUserPermissions } from '@zunta/configurations'

import Card from '@/components/Card.vue'
import ScrollView from '@/components/ScrollView.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Icon from '@/components/Icon.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'
import Input from '@/components/inputs/Input.vue'
import Table from '@/components/tables/Table.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'

@Component({
  props: {
    minHeight: {
      type: String
    },
    maxHeight: {
      type: String,
      default: '300px'
    }
  },
  components: {
    Table,
    Input,
    Icon,
    DateTimeLabel,
    ScrollView,
    Card,
    EditHistoryCommentModal
  }
})
export default class ResidentHistory extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  EUserPermissions: any = EUserPermissions
  user: User = Api.getUser() as User
  historyNote: string = ''

  filters: IResidentEventHistoryFiltersDTO = {
    limit: 20,
    skip: 0,
    sortBy: 'date',
    sortOrder: ESortOrder.DESC
  }

  selectedHistoryItem: Partial<ICollectionHistory> | null = {
    note: ''
  }

  isLoading: boolean = false
  showHistoryModal: boolean = false

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    useQuery: false,
    usePagination: true,
    fetchFunction: this.fetchResidentHistory,
    maxHeight: this.$props.maxHeight,
    minHeight: this.$props.minHeight,
    columns: [
      {
        class: '',
        minWidth: '150px',
        width: 15,
        key: 'eventType',
        searchKey: 'eventType',
        hasSort: true,
        hasSearch: true,
        label: 'Event Type',
        type: ETableColumnType.default
      },
      {
        class: '',
        minWidth: '350px',
        width: 45,
        key: 'event',
        searchKey: 'event',
        hasSort: true,
        hasSearch: true,
        label: 'Event',
        type: ETableColumnType.default
      },
      {
        class: '',
        minWidth: '120px',
        width: 20,
        key: 'date',
        searchKey: 'date',
        hasSort: true,
        hasSearch: true,
        label: 'Date',
        type: ETableColumnType.dateRange
      },
      {
        class: '',
        minWidth: '150px',
        width: 16,
        key: 'user',
        searchKey: 'user',
        hasSort: true,
        hasSearch: true,
        label: 'User',
        type: ETableColumnType.default
      },
      {
        class: '',
        minWidth: '20px',
        width: 4,
        key: 'actions',
        hasSort: false,
        hasSearch: false
      }
    ]
  }

  get residentId () {
    return this.$route.params.id
  }

  get collectionsHistory () {
    return this.$store.state.resident.collectionHistory
  }

  get collectionHistoryTotal () {
    return this.$store.state.resident.collectionHistoryTotal
  }

  async fetchResidentHistory (filters: any): Promise<void> {
    try {
      await this.residentModuleInstance.fetchResidentHistoryByFilters({
        residentId: this.residentId,
        filters
      })
    } finally {
      this.scrollToBottomOfTheHistory()
    }
  }

  openNoteModal (item: Partial<ICollectionHistory>) {
    this.selectedHistoryItem = { ...item }
    this.showHistoryModal = true
  }

  closeNoteModal () {
    this.selectedHistoryItem = {
      note: null
    }
    this.showHistoryModal = false
  }

  scrollToBottomOfTheHistory () {
    // this.$nextTick(() => {
    //   const el = document.querySelector('.resident-history .scroll-area')
    //   if (el) {
    //     el.scrollTop = el.scrollHeight
    //   }
    // })
  }
}
